import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "users",
    object: "user",
    header: [
      { text: "ID", value: "id" },
      { text: "Fullname", value: "fullname" },
     // { text: "Apellido", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Profile", value: "profile_picture" },
      { text: "Orders", value: "order_actions" },
      { text: "Notes", value: "notes_actions" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then((response) => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    logoutUser({ commit}, user_id) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
            .post(config.api_url + 'logout_user',{user_id})
            .then((response) => {
              commit("success");
              resolve(response.data);
            })
            .catch((error) => {
              console.log(error);
              commit("error");
              reject(error.response.data);
            });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
